module.exports = __webpack_public_path__ + "media/images/pic/labels/a2_2a-e61314843498384996802ae32b94f487.png";